import React, { useState } from "react";

const SelectPreferenceModal = ({
    title,
    options,
    value,
    isOpen,
    onClose,
    onSubmit,
}) => {
    const [selected, setSelected] = useState(value || "");

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
            <div className="bg-white rounded p-6 w-full max-w-sm relative">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-xl"
                >
                    ✖
                </button>
                <h2 className="text-lg font-bold mb-4">{title}</h2>
                <select
                    value={selected}
                    onChange={(e) => setSelected(e.target.value)}
                    className="border rounded p-2 w-full"
                >
                    <option value="">Select {title}</option>
                    {options.map((opt) => (
                        <option key={opt} value={opt}>
                            {opt}
                        </option>
                    ))}
                </select>
                <button
                    onClick={() => onSubmit(selected)}
                    className="mt-4 w-full bg-pink-600 text-white py-2 rounded hover:bg-pink-700"
                >
                    Submit
                </button>
            </div>
        </div>
    );
};

export default SelectPreferenceModal;
